/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whywedo_Label2Inputs */

const ja_careers_whywedo_label2 = /** @type {(inputs: Careers_Whywedo_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WHY WE DO IT`)
};

const en_careers_whywedo_label2 = /** @type {(inputs: Careers_Whywedo_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WHY WE DO IT`)
};

/**
* | output |
* | --- |
* | "WHY WE DO IT" |
*
* @param {Careers_Whywedo_Label2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whywedo_label2 = /** @type {((inputs?: Careers_Whywedo_Label2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whywedo_Label2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whywedo_label2(inputs)
	return en_careers_whywedo_label2(inputs)
});
export { careers_whywedo_label2 as "careers_whyWeDo_label" }